import Form from 'components/Form';
import {
  Box,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
  CardMedia,
} from '@mui/material';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';
import nrsPoint from 'assets/nrs-point.svg';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}
const NRSScale = (props: Props) => {
  const { disabled, setValue, getValues, register } = props;

  return (
    <>
      <SectionTitle title="NRS" mt={3} mb={2} />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer>
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  borderTop: '1px solid lightgray',
                  whiteSpace: 'nowrap',
                  fontSize: '12px',
                }}
              >
                각 점수 입력란에 0-10 사이의 숫자를 입력하세요.
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                  paddingLeft: '30px',
                }}
              >
                입실
                <br />
                5분이내
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{ borderTop: '1px solid lightgray', fontSize: '12px' }}
              >
                입실
                <br />
                5분이후
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{ borderTop: '1px solid lightgray', fontSize: '12px' }}
              >
                입실 or
                <br />
                중재
                <br />
                30분후
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <StyledTableCellTwo
                align="left"
                sx={{
                  padding: '16px',
                  width: '100%',
                  whiteSpace: 'pre-wrap',
                }}
              >
                <CardMedia
                  width={900}
                  height={250}
                  component="img"
                  image={nrsPoint}
                  sx={{ objectFit: 'contain' }}
                />
              </StyledTableCellTwo>
              <StyledTableCellWithoutLeftTwo>
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  sx={{ width: '80px', marginLeft: '30px' }}
                  type="number"
                  {...register('nrs01', {
                    onChange: e => {
                      if (e.target.value > 10) {
                        alert('0-10까지 입력할 수 있습니다.');
                        setValue('nrs01', 0);
                      }
                      if (e.target.value < 0) {
                        alert('음수는 불가능합니다.');
                        setValue('nrs01', 0);
                      }
                      setValue('nrs01', Number(e.target.value));
                    },
                  })}
                />
              </StyledTableCellWithoutLeftTwo>
              <StyledTableCellWithoutLeftTwo>
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  sx={{ width: '80px', margin: '0 30px 0 30px' }}
                  type="number"
                  {...register('nrs02', {
                    onChange: e => {
                      if (e.target.value > 10) {
                        alert('0-10까지 입력할 수 있습니다.');
                        setValue('nrs02', 0);
                      }
                      if (e.target.value < 0) {
                        alert('음수는 불가능합니다.');
                        setValue('nrs02', 0);
                      }
                      setValue('nrs02', Number(e.target.value));
                    },
                  })}
                />
              </StyledTableCellWithoutLeftTwo>
              <StyledTableCellWithoutLeftTwo>
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  sx={{ width: '80px' }}
                  type="number"
                  {...register('nrs03', {
                    onChange: e => {
                      if (e.target.value > 10) {
                        alert('0-10까지 입력할 수 있습니다.');
                        setValue('nrs03', 0);
                      }
                      if (e.target.value < 0) {
                        alert('음수는 불가능합니다.');
                        setValue('nrs03', 0);
                      }
                      setValue('nrs03', Number(e.target.value));
                    },
                  })}
                />
              </StyledTableCellWithoutLeftTwo>
            </TableRow>
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default NRSScale;
